import { useNavigate } from 'react-router-dom';
import { UserPlus, UserMinus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useFollow } from '../../hooks/useUser';

interface FollowButtonProps {
  userId: string;
  initialFollowing?: boolean;
  size?: 'sm' | 'default' | 'lg';
  onFollowChange?: (isFollowing: boolean) => void;
  requiresAuth?: boolean;
}

export default function FollowButton({
  userId,
  initialFollowing = false,
  size = 'default',
  onFollowChange,
  requiresAuth = false,
}: FollowButtonProps) {
  const navigate = useNavigate();
  const { isFollowing, loading, toggle } = useFollow(userId, initialFollowing);

  const handleClick = async () => {
    if (requiresAuth) {
      navigate('/login');
      return;
    }
    const previousState = isFollowing;
    const success = await toggle();
    // Only notify parent if mutation succeeded
    if (success) {
      onFollowChange?.(!previousState);
    }
  };

  return (
    <Button
      variant={isFollowing ? 'outline' : 'default'}
      size={size}
      onClick={handleClick}
      loading={loading}
      className="font-mono font-bold"
    >
      {isFollowing ? (
        <>
          <UserMinus className="h-4 w-4" />
          Following
        </>
      ) : (
        <>
          <UserPlus className="h-4 w-4" />
          Follow
        </>
      )}
    </Button>
  );
}
